import { useRef, useEffect, useState, useMemo } from "react";
import { Plane } from "lucide-react";
import Cellempty from "./Cellempty";

export default function SeatSelection(props) {
    const {
        Allsegment,
        SeatData,
        memberDetails,
        setSelectedSeats,
        setTotalSeatPrice,
        totalPax,
        setMemberDetails,
    } = props
    // const [selectedSeat, setSelectedSeat] = useState(null);
    const scrollRef = useRef(null);

    // Enable mouse wheel horizontal scroll
    useEffect(() => {
        const scrollContainer = scrollRef.current;
        if (!scrollContainer) return;

        const handleWheel = (e) => {
            if (e.deltaY !== 0) {
                e.preventDefault();
                scrollContainer.scrollBy({
                    left: e.deltaY,
                    behavior: "smooth",
                });
            }
        };

        scrollContainer.addEventListener("wheel", handleWheel, { passive: false });
        return () =>
            scrollContainer.removeEventListener("wheel", handleWheel);
    }, []);

    const handleScroll = (dir) => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({
                left: dir === "left" ? -200 : 200, // adjust px as needed
                behavior: "smooth",
            });
        }
    };
    const [selectedCells, setSelectedCells] = useState([]);
    const [selectedSeats, setSelectedSeat] = useState({});
    const selectSeat = (item, segmentid) => {
        // for (const segment in selectedSeats) {
        const seats = selectedSeats?.[segmentid] || [];
        // check if skipSeatNo exists in this segment
        const hasSkipSeat = seats.some(s => s.seatNo === item.seatNo);
        if (!hasSkipSeat && selectedSeats?.[segmentid]?.length > 0 && selectedSeats?.[segmentid]?.length >= totalPax) {
            alert(`You have already selected (${selectedSeats[segmentid].length}) seats. Maximum allowed (${totalPax})`);
            return false;
        }
        // }
        setTimeout(function () {
            setSelectedCells((prev) =>
                prev.includes(item.seatNo)
                    ? prev.filter((i) => i !== item.seatNo) // remove if already selected
                    : [...prev, item.seatNo] // add if not selected
            );

            setSelectedSeat((prev) => {
                const group = segmentid; // e.g., "515"
                const existing = prev[group] || [];
                // check if already exists (toggle behavior)
                const alreadySelected = existing.find((s) => s.seatNo === item.seatNo);
                return {
                    ...prev,
                    [group]: alreadySelected
                        ? existing.filter((s) => s.seatNo !== item.seatNo) // remove
                        : [...existing, { seatNo: item.seatNo, amount: item.amount }], // add
                };
            });
        }, 10);
    }

    const totalSeatPrice = useMemo(() => {
        setSelectedSeats(selectedSeats)
        let total = 0;
        Object.values(selectedSeats).forEach((group) => {
            group.forEach((s) => {
                total += s.amount; // directly from selectedSeats
            });
        });
        setTotalSeatPrice(total)
        return total;
    }, [selectedSeats]);


    useEffect(() => {
        const travellerInfo = memberDetails.map((pitem, index) => {
            const newItem = { ...pitem };
            if (pitem.addonns === true) {
                const selectedCustomr = {};
                Allsegment.forEach((itemSg) => {
                    const indexkey = itemSg.originAirportCode + '-' + itemSg.destinationAirportCode;
                    const value = selectedSeats?.[itemSg.segmentid]?.[index];
                    if (value !== undefined) {
                        // Initialize array for this indexkey if not already
                        if (!selectedCustomr[indexkey]) {
                            selectedCustomr[indexkey] = [];
                        }
                        // Push value(s) into the array
                        if (Array.isArray(value)) {
                            value.forEach(v => selectedCustomr[indexkey].push({
                                seatNo: v.seatNo,
                                amount: v.amount
                            }));
                        } else {
                            selectedCustomr[indexkey].push({
                                seatNo: value.seatNo,
                                amount: value.amount
                            });
                        }
                    }
                });
                newItem.selectedSeat = selectedCustomr;
            }
            return newItem;
        });

        setMemberDetails(travellerInfo);

    }, [selectedSeats]);

    const [activeTab, setActiveTab] = useState(Object.keys(SeatData)[0] || 0);

    return (
        <>
            <div className="w-full">
                {/* Tab Header */}
                <div className="flex  overflow-hidden">
                    <div className="flex gap-2">
                        {Allsegment.map((tab) => (
                            <button
                                type="button"
                                key={tab.segmentid}
                                // onClick={() => setActiveTab(tab.key)}
                                onClick={() => {
                                    setActiveTab(tab.segmentid);
                                }}
                                className={`flex text-[15px] font-medium px-3 py-2 rounded-lg text-center transition ${activeTab == tab.segmentid
                                    ? "bg-blue-500 text-white"
                                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                                    }`}
                            >
                                {tab.originCityName}&nbsp; <Plane size={15} className="planicons" />&nbsp;{tab.destinationCityName}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Tab Content */}
                <div className="p-2 bg-white">
                    {Allsegment.map((itemSg, keys) => (
                        <>
                            {activeTab == itemSg.segmentid && (
                                <div className="w-full pr-2">
                                    <div className="flex gap-6 items-center mb-4 text-sm">
                                        <div className="flex items-center gap-1">
                                            <span className="w-4 h-4 bg-green-500 border rounded-sm"></span> Selected
                                        </div>
                                        <div className="flex items-center gap-1">
                                            <span className="w-4 h-4 bg-gray-400 border rounded-sm"></span> Booked
                                        </div>
                                        {SeatData?.[itemSg.segmentid] && SeatData[itemSg.segmentid]?.value?.ColorArr.map((price, x) => (
                                            <div key={x} className="flex items-center gap-1">
                                                <span style={{ background: '#' + price.color }} className={`w-4 h-4 border rounded-sm`}></span> ₹{price.amount}
                                            </div>
                                        ))}
                                    </div>
                                    <div className="space-y-4">
                                        <div className="relative">
                                            <button
                                                type="button"
                                                onClick={() => handleScroll("left")}
                                                className="absolute left-0 top-1/2 -translate-y-1/2 z-10 p-2 bg-white shadow rounded-full"
                                            >
                                                ←
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => handleScroll("right")}
                                                className="absolute right-0 top-1/2 -translate-y-1/2 z-10 p-2 bg-white shadow rounded-full"
                                            >
                                                →
                                            </button>

                                            {/* Seat Map */}
                                            <div ref={scrollRef} className="overflow-x-auto scrollbar-hide p-4 border rounded-lg">
                                                <div className="flex">
                                                    {/* Plane head */}
                                                    <img src="/aircraft-head.png" style={{ maxWidth: '82%', width: '100%', margin: '0 auto', height: '245px' }} />
                                                    {/* Seats */}
                                                    <div className="flex">
                                                        <div className="flex flex-col-reverse">
                                                            <button
                                                                type="button"
                                                                id="SeatID1A"
                                                                value="1A"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">A</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                id="SeatID1B"
                                                                value="1B"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">B</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                id="SeatID1C"
                                                                value="1C"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">C</span>
                                                            </button>
                                                            <div className="EmptyCellBox">
                                                                <span className="Cell_text" />
                                                            </div>
                                                            <button
                                                                type="button"
                                                                id="SeatID1D"
                                                                value="1D"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">D</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                id="SeatID1E"
                                                                value="1E"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">E</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                id="SeatID1F"
                                                                value="1F"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">F</span>
                                                            </button>
                                                        </div>

                                                        {SeatData?.[itemSg.segmentid] && SeatData[itemSg.segmentid]?.seatLayout.map((trValue, x) =>
                                                            <div className="flex flex-col-reverse" key={x + 'tabledddd'}>
                                                                {trValue.map((tdValue, xs) =>
                                                                    tdValue.isAisle ?
                                                                        tdValue.seatNo ?
                                                                            <>
                                                                                <button type="button" key={xs + 'seatnumber'} id={'SeatID' + tdValue.seatNo} value={tdValue.seatNo} onClick={() => selectSeat(tdValue, itemSg.segmentid)} className={`inline ${(selectedSeats[itemSg.segmentid] || []).some((s) => s.seatNo === tdValue.seatNo) ? "CellSelected" : tdValue.Cell} ${tdValue.CellTypeC}`} title={tdValue.tools} style={{ background: '#' + tdValue.CellColor }} >
                                                                                    <span className='Cell_text'>{tdValue.seatNo}</span>
                                                                                </button>
                                                                            </>
                                                                            : (
                                                                                <Cellempty key={xs + 'cellemp'} />
                                                                            )
                                                                        : (
                                                                            tdValue.seatNo ?
                                                                                <>
                                                                                    <button type="button" key={xs + 'seatnumber'} id={'SeatID' + tdValue.seatNo} value={tdValue.seatNo} onClick={() => selectSeat(tdValue, itemSg.segmentid)} className={`inline ${(selectedSeats[itemSg.segmentid] || []).some((s) => s.seatNo === tdValue.seatNo) ? "CellSelected" : tdValue.Cell} ${tdValue.CellTypeC}`} title={tdValue.tools} style={{ background: '#' + tdValue.CellColor }} >
                                                                                        <span className='Cell_text'>{tdValue.seatNo}</span>
                                                                                    </button>
                                                                                </>
                                                                                : (
                                                                                    <Cellempty key={xs + 'cellemp'} />
                                                                                )
                                                                        )
                                                                )}
                                                            </div>
                                                        )}

                                                        <div className="flex flex-col">
                                                            <button
                                                                type="button"
                                                                id="SeatID1A"
                                                                value="1A"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">B</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                id="SeatID1B"
                                                                value="1B"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">A</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                id="SeatID1C"
                                                                value="1C"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">C</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                id="SeatID1D"
                                                                value="1D"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">K</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                id="SeatID1D"
                                                                value="1D"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">S</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                id="SeatID1E"
                                                                value="1E"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">I</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                id="SeatID1F"
                                                                value="1F"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">DE</span>
                                                            </button>
                                                        </div>
                                                        <div className="flex flex-col">
                                                            <button
                                                                type="button"
                                                                id="SeatID1F"
                                                                value="1F"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">&nbsp;</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                id="SeatID1F"
                                                                value="1F"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">&nbsp;</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                id="SeatID1F"
                                                                value="1F"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">&nbsp;</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                id="SeatID1F"
                                                                value="1F"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">&nbsp;</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                id="SeatID1F"
                                                                value="1F"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">&nbsp;</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                id="SeatID1F"
                                                                value="1F"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">&nbsp;</span>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                id="SeatID1F"
                                                                value="1F"
                                                                className="inline CellBoked "
                                                                style={{ color: 'black' }}
                                                            >
                                                                <span className="Cell_text">&nbsp;</span>
                                                            </button>
                                                        </div>

                                                    </div>
                                                    {/* Plane tail */}
                                                    {/* <img src="/aircraft-tail.png" style={{ maxWidth: '82%', width: '100%', margin: '0 auto', height: '245px' }} /> */}

                                                </div>
                                            </div>
                                        </div>
                                        {selectedSeats && selectedSeats?.[itemSg.segmentid] && (
                                            <>
                                                <div className="mt-3 grid grid-cols-2 sm:grid-cols-2 md:grid-cols-6 lg:grid-cols-6 gap-4">
                                                    {memberDetails.map((pitem, index) => {
                                                        if (pitem.addonns) {
                                                            return (
                                                                <div className=" p-2 border rounded bg-blue-50">
                                                                    <span>{pitem.pax}-{pitem.PaxCount}</span> <br />
                                                                    Seat: <span className="text-blue-600">{selectedSeats?.[itemSg.segmentid][index]?.seatNo}</span>
                                                                </div>
                                                            )
                                                        }
                                                    })}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                        </>
                    ))}
                </div>
            </div>




            {/* <div className="w-full">
                <div className="flex gap-2 mb-4">
                    {sectors.map((sec) => (
                        <button
                            key={sec}
                            onClick={() => setSelectedSector(sec)}
                            className={`px-4 py-2 rounded-lg border ${selectedSector === sec
                                ? "bg-orange-500 text-white border-orange-500"
                                : "bg-white border-gray-300"
                                }`}
                        >
                            {sec}
                        </button>
                    ))}
                </div>
                <div className="flex gap-6 items-center mb-4 text-sm">
                    <div className="flex items-center gap-1">
                        <span className="w-4 h-4 bg-green-500 border rounded-sm"></span> Selected
                    </div>
                    <div className="flex items-center gap-1">
                        <span className="w-4 h-4 bg-gray-400 border rounded-sm"></span> Booked
                    </div>
                    {Object.entries(seatPrices).map(([price, color]) => (
                        <div key={price} className="flex items-center gap-1">
                            <span className={`w-4 h-4 ${color} border rounded-sm`}></span> ₹{price}
                        </div>
                    ))}
                </div>
                <div className="relative">
                    <button
                        onClick={() => handleScroll("left")}
                        className="absolute left-0 top-1/2 -translate-y-1/2 z-10 p-2 bg-white shadow rounded-full"
                    >
                        ←
                    </button>
                    <button
                        onClick={() => handleScroll("right")}
                        className="absolute right-0 top-1/2 -translate-y-1/2 z-10 p-2 bg-white shadow rounded-full"
                    >
                        →
                    </button>
                    <div ref={scrollRef} className="overflow-x-auto scrollbar-hide">
                        <div className="flex">
                            <img src="/aircraft-head.png" className=" aircrafthead" />

                            <div className="flex">
                                {Array.from({ length: rows }, (_, rowIndex) => (
                                    <div key={rowIndex} className="flex flex-col mx-2">
                                        {seatsPerRow.map((seat) => {
                                            const seatId = `${rowIndex + 1}${seat}`;
                                            const isBooked = seatId === "6E"; // demo
                                            const isSelected = selectedSeat === seatId;

                                            return (
                                                <button
                                                    key={seatId}
                                                    disabled={isBooked}
                                                    onClick={() => setSelectedSeat(seatId)}
                                                    className={`w-10 h-10 m-1 text-xs flex items-center justify-center border rounded ${isBooked
                                                        ? "bg-gray-300 cursor-not-allowed line-through"
                                                        : isSelected
                                                            ? "bg-green-500 text-white"
                                                            : "bg-yellow-400"
                                                        }`}
                                                >
                                                    {seatId}
                                                </button>
                                            );
                                        })}
                                    </div>
                                ))}
                            </div>
                            <img src="/aircraft-tail.png" className=" aircrafttail" />
                        </div>
                    </div>
                </div>
                {selectedSeat && (
                    <div className="mt-4 p-3 border rounded bg-orange-50">
                        <strong>ADULT-1</strong> <br />
                        SEAT: <span className="text-orange-600">{selectedSeat}</span>
                    </div>
                )}
            </div> */}
        </>
    );
}
